export interface Group {
    groupId: string;
    groupName: string;
    subGroups?: Group[];
    groupCode?: string;
}
